import { defineMessages } from 'react-intl';

export default defineMessages({
    cancel: {
        id: 'ax.nag.Cancel',
        defaultMessage: 'Cancell'
    },
    send: {
        id: 'ax.nag.button.Send',
        defaultMessage: 'Send'
    },
    yes: {
        id: 'ax.nag.Yes',
        defaultMessage: 'Yes'
    },
    not: {
        id: 'ax.nag.No',
        defaultMessage: 'No'
    },
    title: {
        id: 'ax.nag.delete.nag',
        defaultMessage: 'Delete Nag'
    },
    pageTitle: {
        id: 'ax.nag.title.nag',
        defaultMessage: 'Update NAGS Key'
    },
    nagTitle: {
        id: 'ax.nag.search.nag',
        defaultMessage: 'Search NAGS'
    },
    nagMessage: {
        id: 'ax.nag.search.nag.message',
        defaultMessage: 'NAG not found'
    },
    tableNagAmount: {
        id: 'ax.nag.nag.summary.title.nagAmount',
        defaultMessage: 'ESTIMATE AMOUNT'
    },
    tableDeductibleAmount: {
        id: 'ax.nag.nag.summary.title.deductibleAmount',
        defaultMessage: 'AMOUNT DEDUCTIBLE'
    },
    tableGrossAmount: {
        id: 'ax.nag.nag.summary.title.grossAmount',
        defaultMessage: 'TOTAL'
    },
    tableNagKey: {
        id: 'ax.nag.name.nag',
        defaultMessage: 'NAG KEY'
    },
    tableAction: {
        id: 'ax.nag.name.actions',
        defaultMessage: 'ACTIONS'
    },
    updateButton: {
        id: 'ax.nag.name.actions.update',
        defaultMessage: 'Update'
    },
    alertMessageWithResult: {
        id: 'ax.nag.delete.nag.message',
        defaultMessage: 'Are you sure you want to delete the record?'
    },
    pageTitleGlass: {
        id: 'ax.nag.title.nag.glass',
        defaultMessage: 'Glass data'
    },
    error: {
        id: 'ax.nag.alert.nag.message.error',
        defaultMessage: 'Error'
    },
    errorMessage: {
        id: 'ax.nag.alert.nag.message.errorMessage',
        defaultMessage: 'Please try again later.!'
    },
});
